<template>
  <div class="data-row">
    <v-icon
      :size="20"
      color="var(--color-text)"
    >
      {{ icon }}
    </v-icon>
    <strong class="category-style">{{ category }}:</strong>
    <div
      v-if="isLoading"
      class="bouncing-dots"
    >
      <div class="dot" />
      <div class="dot" />
      <div class="dot" />
    </div>
    <span
      v-else
      class="value-style"
    >{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: "LoadingDataRow",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: "-",
    },
  },
};
</script>

<style scoped>
.data-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.bouncing-dots {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dot {
  width: 6px;
  height: 6px;
  background-color: var(--color-text);
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.category-style {
  color: var(--color-text);
  font-size: 12px;
}

.value-style {
  color: var(--color-text);
  font-size: 12px;
  max-lines: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
